import Icon from '@ant-design/icons';
import * as React from 'react';

const BriefcaseSvg = (props: any) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" width="12px" height="12px" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect width="20" height="14" x="2" y="7" rx="2" ry="2" />
    <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
  </svg>
);

export const BriefcaseIcon = (props) => (
  <Icon component={BriefcaseSvg} {...props} />
);
